var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DocumentUploadModalForm, Modal, usePregnancyData, useShowToast, } from "@madmedical/ui";
import { useMe, usePatientId } from "@madmedical/user";
import { useTranslation } from "@madmedical/i18n";
import { useAttachDocumentMutation, useUploadDocumentMutation } from "../api";
const UploadPregnancyDocModal = ({ open, onClose }) => {
    const { patientId } = usePatientId();
    const [upload, { isLoading: isUploadLoading }] = useUploadDocumentMutation();
    const [attach, { isLoading: isAttachLoading }] = useAttachDocumentMutation();
    const showToast = useShowToast();
    const { t } = useTranslation();
    const { pregnancyData } = usePregnancyData();
    const pregnancyId = pregnancyData === null || pregnancyData === void 0 ? void 0 : pregnancyData.id;
    const { doctor } = useMe();
    const doctorId = doctor === null || doctor === void 0 ? void 0 : doctor.userId;
    const handleSubmit = (files) => __awaiter(void 0, void 0, void 0, function* () {
        const data = new FormData();
        files.forEach(({ file }) => data.append("file[]", file));
        const documents = yield upload(data).unwrap();
        const promises = documents.map((document, index) => {
            var _a;
            return attach({
                id: document.id,
                patientId,
                note: files[index].note,
                service: (_a = files[index].service) !== null && _a !== void 0 ? _a : undefined,
                pregnancyId,
                doctorId,
            }).unwrap();
        });
        yield Promise.all(promises);
        showToast(t("successfulUpload"), { variant: "success" });
        onClose();
    });
    return (_jsx(Modal, Object.assign({ open: open, size: "sm", onClose: onClose }, { children: _jsx(DocumentUploadModalForm, { isUploading: isUploadLoading || isAttachLoading, onSubmit: handleSubmit, onClose: onClose }) })));
};
export default UploadPregnancyDocModal;
